import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { getTheme } from '../redux/selectors/appSelectors';
import { useSelector } from 'react-redux';

const TextField = ({
    type = 'text',
    placeholder = '',
    icon = null,
    value,
    onChange,
    className = '',
    style = {},
    isPassword = false,
    iconHeight = null,
    ...rest
}) => {

    const [showPassword, setShowPassword] = useState(false);
    const inputType = isPassword ? (showPassword ? 'text' : 'password') : type;

    const theme = useSelector(getTheme);
    const isDarkMode = theme === 'dark';

    return (
        <div className={`login-custom-input-wrapper position-relative ${className}`} style={style}>
            {icon && (
                <img
                    src={icon}
                    alt="input-icon"
                    className="input-image"
                    style={{ height: iconHeight || 'auto', }}
                />
            )}
            <Form.Control
                // type={type}
                type={inputType}
                placeholder={placeholder}
                value={value}
                onChange={onChange}
                // className="login-custom-textfield"
                className={`login-custom-textfield ${rest.className || ''}`}
                {...rest}
                style={{
                    paddingLeft: icon ? '12px' : "0px",
                    ...rest.style,
                }}
            />
            {isPassword && (
                <span
                    onClick={() => setShowPassword(!showPassword)}
                    style={{
                        position: 'absolute',
                        right: 18,
                        cursor: 'pointer',
                        color: '#6c757d',
                        zIndex: 2,
                    }}
                >
                    {showPassword ? <BsEye size={18} /> : <BsEyeSlash size={18} />}
                </span>
            )}
        </div>
    );
};

export default TextField;
